import type { HeroId } from '../types';

/**
 * Pip, Bramble, Cleo, and Otto start in the glen. A later critter has a trophy
 * mark above 0 and a matching road stop. These marks are not the difficulty bands.
 */
export const CRITTER_GATES: readonly { id: HeroId; at: number }[] = [
  { id: 'pip', at: 0 },
  { id: 'bramble', at: 0 },
  { id: 'cleo', at: 0 },
  { id: 'otto', at: 0 },
  { id: 'bruno', at: 100 },
  { id: 'tuck', at: 180 },
  { id: 'thistle', at: 230 },
  { id: 'marlow', at: 310 },
  { id: 'wren', at: 410 },
  { id: 'juniper', at: 490 },
  { id: 'lumi', at: 590 },
  { id: 'barley', at: 690 },
  { id: 'fern', at: 750 },
  { id: 'posy', at: 880 },
  { id: 'dash', at: 1060 },
];
